"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuidedFlowBlockWrapper = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importStar(require("react"));
var Utils_1 = require("./Utils");
var MaybeWrap_1 = __importDefault(require("@CommonFrontend/Utils/MaybeWrap"));
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var scroll_into_view_if_needed_1 = __importDefault(require("scroll-into-view-if-needed"));
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var inversify_react_1 = require("inversify-react");
var mobx_react_1 = require("mobx-react");
var GuidedFlowButtons_1 = require("./GuidedFlowButtons");
var styles = __importStar(require("./GuidedFlow.css"));
var dynamic_1 = require("@vanilla-extract/dynamic");
var GuidedFlowButtons_css_1 = require("./GuidedFlowButtons.css");
var lodash_1 = require("lodash");
var GuidedFlowBlockWrapper = function (_a) {
    var _b;
    var usingFeature = _a.usingFeature, tokens = _a.tokens, isPrintMode = _a.isPrintMode, blockType = _a.blockType, children = _a.children, blockContainerSelector = _a.blockContainerSelector;
    var guidedFlowStore = (0, inversify_react_1.useInjection)("guidedFlowStore");
    var acceptedInCurrentSession = (0, inversify_react_1.useInjection)("acceptedInCurrentSession");
    var acceptBlockSettings = (0, inversify_react_1.useInjection)("acceptBlockSettings");
    var isAccepted = ((_b = acceptBlockSettings.accepters.finalisedAccepters) === null || _b === void 0 ? void 0 : _b.length) === acceptBlockSettings.accepters.number;
    var steps = (0, Utils_1.getGuidableStepsFromTokens)(tokens);
    var addAcceptForm = blockType === BlockTypes_1.BlockType.Agreement;
    if (addAcceptForm) {
        steps.push({ id: "accept-form", type: "component", subType: "accept-form" });
    }
    var isClientSide = typeof document !== "undefined";
    var hasSteps = addAcceptForm ? steps.length > 1 : steps.length > 0;
    var useGuidedFlow = usingFeature(FeatureFlag_1.default.SignatureInitialsWidgets) &&
        hasSteps &&
        !isPrintMode &&
        isClientSide &&
        !acceptedInCurrentSession() &&
        !isAccepted;
    if (useGuidedFlow) {
        guidedFlowStore.registerSteps(steps, Utils_1.makeGuidableText);
    }
    return (react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (wrapperChild) {
            if (useGuidedFlow) {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(GuidedFlowContainer, { acceptedInCurrentSession: acceptedInCurrentSession, blockContainerSelector: blockContainerSelector }),
                    wrapperChild));
            }
            return undefined;
        } }, children));
};
exports.GuidedFlowBlockWrapper = GuidedFlowBlockWrapper;
var GuidedFlowContainer = (0, mobx_react_1.observer)(function (_a) {
    var blockContainerSelector = _a.blockContainerSelector, acceptedInCurrentSession = _a.acceptedInCurrentSession;
    var guidedFlowStore = (0, inversify_react_1.useInjection)("guidedFlowStore");
    var isMobile = (0, inversify_react_1.useInjection)("isMobile");
    var acceptFlowGlobalStore = (0, inversify_react_1.useInjection)("acceptFlowGlobalStore");
    var guidedFlowButtonRef = (0, react_1.useRef)();
    var resizeObserver = (0, react_1.useRef)(null);
    var coords = guidedFlowStore.coords;
    var handleClick = function () {
        var nextStep = guidedFlowStore.incrementStep();
        var nextElement = nextStep ? document.querySelector((0, Utils_1.getElementSelector)(nextStep.type, nextStep.id)) : null;
        if (nextElement && nextStep) {
            (0, scroll_into_view_if_needed_1.default)(nextElement, (0, Utils_1.getScrollOptionsByStepType)(nextStep.type));
        }
    };
    var _b = __read((0, react_1.useState)("start"), 2), state = _b[0], setState = _b[1];
    (0, react_1.useEffect)(function () {
        if (guidedFlowStore.currentStepState) {
            if (guidedFlowStore.currentStepState.completed) {
                if (acceptedInCurrentSession()) {
                    setState("accepted");
                }
                else {
                    setState("complete");
                }
            }
            else {
                setState("pending");
            }
        }
        var positionGuidedFlow = function () {
            var _a, _b, _c, _d;
            var isMobileDevice = isMobile();
            var currentSlot = acceptFlowGlobalStore.currentSlot || 0;
            var currentStepIndex = guidedFlowStore.getCurrentStepIndex;
            var contentColumnsSelector = "".concat(blockContainerSelector, " .columns");
            var contentColumnsElement = document.querySelector(contentColumnsSelector);
            var buttonWidth = (_b = (_a = guidedFlowButtonRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0;
            if (!contentColumnsElement) {
                console.error("[Guided Flow] Could not find block \"".concat(contentColumnsSelector, "\" element"));
                return;
            }
            var positionAtContentStart = !guidedFlowStore.currentStepState;
            if (positionAtContentStart) {
                guidedFlowStore.setCoords((0, Utils_1.getStartGuidedFlowOffsets)({ contentColumnsElement: contentColumnsElement, buttonWidth: buttonWidth, buttonHeight: GuidedFlowButtons_css_1.height }));
            }
            else {
                var selector = (0, Utils_1.getElementSelector)(guidedFlowStore.currentStepState.type, guidedFlowStore.currentStepState.id);
                var guidableElement = document.querySelector(selector);
                if (!guidableElement)
                    return;
                if (guidedFlowStore.currentStepState.id === "accept-form") {
                    var firstAcceptFormInput = (_c = guidableElement === null || guidableElement === void 0 ? void 0 : guidableElement.children[0]) === null || _c === void 0 ? void 0 : _c.children[1];
                    if (!firstAcceptFormInput)
                        return;
                    guidedFlowStore.setCoords((0, Utils_1.getAcceptFormGuidedFlowOffsets)({
                        isMobileDevice: isMobileDevice,
                        guidableElement: guidableElement,
                        firstAcceptFormInput: firstAcceptFormInput,
                        buttonWidth: buttonWidth,
                        buttonHeight: GuidedFlowButtons_css_1.height,
                    }));
                }
                else {
                    var targetSlot = (_d = guidableElement === null || guidableElement === void 0 ? void 0 : guidableElement.children[0]) === null || _d === void 0 ? void 0 : _d.children[currentSlot];
                    if (!targetSlot) {
                        console.error("[Guided Flow] Could not find target slot for step ".concat(currentStepIndex, " and slot ").concat(currentSlot));
                        return;
                    }
                    guidedFlowStore.setCoords((0, Utils_1.getSignatureSlotGuidedFlowOffsets)({
                        isMobileDevice: isMobileDevice,
                        targetSlot: targetSlot,
                        contentColumnsElement: contentColumnsElement,
                        guidableElement: guidableElement,
                        buttonWidth: buttonWidth,
                        buttonHeight: GuidedFlowButtons_css_1.height,
                        blockContainerSelector: blockContainerSelector,
                    }));
                }
            }
        };
        positionGuidedFlow();
        if ("ResizeObserver" in window) {
            (0, lodash_1.defer)(function () {
                var agreementElement = document.querySelector("section.Agreement");
                if (agreementElement && !resizeObserver.current) {
                    resizeObserver.current = new ResizeObserver(function () {
                        positionGuidedFlow();
                    });
                    resizeObserver.current.observe(agreementElement);
                    return function () { var _a; return (_a = resizeObserver.current) === null || _a === void 0 ? void 0 : _a.unobserve(agreementElement); };
                }
                return;
            });
        }
    }, [
        blockContainerSelector,
        guidedFlowStore,
        state,
        isMobile(),
        acceptFlowGlobalStore.currentSlot,
        guidedFlowStore.currentStepState,
        acceptedInCurrentSession,
    ]);
    if (state === "accepted") {
        return null;
    }
    return (react_1.default.createElement(kaleidoscope_1.Layer, null, function (_a) {
        var _b;
        var _c, _d;
        var zIndex = _a.zIndex;
        return (react_1.default.createElement(kaleidoscope_1.Stack, { ref: guidedFlowButtonRef, className: styles.container, style: __assign({ zIndex: zIndex }, (0, dynamic_1.assignInlineVars)((_b = {},
                _b[styles.offsetY] = "".concat(coords.y, "px"),
                _b[styles.offsetX] = "".concat(coords.x, "px"),
                _b))) },
            state === "start" && !isMobile() && react_1.default.createElement(GuidedFlowButtons_1.FlowStartButton, { onClick: handleClick }),
            state === "pending" && (react_1.default.createElement(GuidedFlowButtons_1.FlowStepPendingFlag, { isMobile: isMobile(), label: (_d = (_c = guidedFlowStore.currentStepState) === null || _c === void 0 ? void 0 : _c.label) !== null && _d !== void 0 ? _d : "" })),
            state === "complete" && !isMobile() && react_1.default.createElement(GuidedFlowButtons_1.FlowGoToNextButton, { onClick: handleClick })));
    }));
});
exports.default = GuidedFlowContainer;
